<template>
  <div />
</template>

<script>
import { userManager } from "@/utils/identity";
import { ROUTE_NAMES } from "@/router/constants";
import { formatQueryError } from "@/utils/queryError";

export default {
  async mounted() {
    let query;
    try {
      await userManager.signoutRedirectCallback();
      await userManager.clearStaleState();
    } catch (error) {
      this.$trackException({
        exception: error,
        properties: { source: "view/SignOutCallback/mounted" }
      });
      query = formatQueryError(error);
    }
    await this.$router.replace({ name: ROUTE_NAMES.LOGIN, query });
  }
};
</script>
